export default __webpack_public_path__ + "static/media/MadalinaMezei.7998ce6a.webp";